module.exports = __webpack_public_path__ + "img/IMG_1962_P_L_Black_MockedUp.fe485cd3.jpg";